import React from 'react'
import { BrandPageProps } from 'src/pages/BrandPage'
import { Container } from 'src/components/common/Container'
import RenderIf from 'src/components/common/RenderIf'
import { Spinner } from 'src/components/common/Spinner'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_r16, Noto_body3_r12 } from 'src/styles/fonts/NotoSansKrFonts'
import styled, { css } from 'styled-components'
import { Icon } from 'src/assets/svg/Icon'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'
import { Divider } from 'src/components/common/Divider'
import { PurchaseHistoryListSpace } from 'src/types/api'
import TopButton from 'src/components/common/TopButton'
import { OnPossessionHistoryCouponCard } from 'src/pages/BrandPage/_components/OnpossessionHistoryCouponCard'

const OnPossessionCoupon = (props: BrandPageProps) => {
  const {
    purchaseCouponListData,
    handleSearchNearbyStore,
    purchaseCouponNoMore,
    purchaseHistoryListQueryTarget,
  } = props

  return (
    <S.BrandOnPossessionContainer $option="flex_column">
      <S.BrandStoreUsAbleNotiContainer $option="flex_row">
        <Icon.Noti />
        <S.BrandStoreUsAbleTypography $fontStyle={Noto_body3_r12} $color="var(--black-50)">
          쿠폰 사용 가능 매장을 꼭 확인하세요!
        </S.BrandStoreUsAbleTypography>
      </S.BrandStoreUsAbleNotiContainer>
      {purchaseCouponListData?.map(
        (couponInfo: PurchaseHistoryListSpace.PurchaseListInterface, index: number) => (
          <Container $option="flex_column" key={index}>
            <OnPossessionHistoryCouponCard {...props} couponInfo={couponInfo} />
            <RenderIf when={purchaseCouponListData?.length - 1 !== index}>
              <Divider />
            </RenderIf>
          </Container>
        ),
      )}
      <RenderIf when={!purchaseCouponNoMore}>
        <Spinner
          ref={purchaseHistoryListQueryTarget}
          $color="var(--black-10)"
          $margin="50px auto 0 auto"
        />
      </RenderIf>
      <RenderIf when={purchaseCouponListData?.length === 0}>
        <S.EmptyPossessionCouponWrap $option="flex_column">
          <Typography $fontStyle={Noto_body1_r16} $color="var(--black-30)">
            보유한 쿠폰이 없습니다.
          </Typography>
        </S.EmptyPossessionCouponWrap>
      </RenderIf>
      <TopButton isPosition="80px" />
      <S.BrandOnPossessionButtonWrap $option="flex_row">
        <Button
          option={ButtonOption3('active')}
          style={S.BrandOnPossessionGoMapButtonStyle}
          onClickFn={handleSearchNearbyStore}
        >
          <Icon.Location />내 주변 매장찾기
        </Button>
      </S.BrandOnPossessionButtonWrap>
    </S.BrandOnPossessionContainer>
  )
}
export default OnPossessionCoupon

const S = {
  BrandOnPossessionContainer: styled(Container)`
    background-color: var(--black-4);
    flex: 1;
    position: relative;
  `,
  EmptyPossessionCouponWrap: styled(Container)`
    justify-content: center;
    text-align: center;
    padding: 100px 0;
    flex: 1;
    background-color: var(--black-4);
    height: 100%;
  `,
  BrandStoreUsAbleNotiContainer: styled(Container)`
    width: calc(100% - 20px);
    margin: 10px auto;
    text-align: center;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.05);
    justify-content: center;
    align-items: center;
  `,
  BrandStoreUsAbleTypography: styled(Typography)`
    padding: 6px;
    display: block;
  `,
  BrandOnPossessionButtonWrap: styled(Container)`
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: 0;
    padding: 10px;
    margin-top: 10px;
    border: none;
    ${layoutMaxSize};
    background-color: var(--white);
    z-index: ${ZIndex.BottomFixedContents};
  `,
  BrandOnPossessionGoMapButtonStyle: css`
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
  `,
}
